<template>
  <div class="sm_bloc">
    <div class="data">{{ data }}</div>
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
import ModalInfo from "../../components/ModalInfo.vue";

export default {
  props: ["data", "title"],
  components: { ModalInfo }
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

.sm_bloc {
  background: $bg_color;
  margin: 20px;
  border-radius: 30px;
  padding: 15px;
  box-shadow: $boxShadow;
  width: 70%;
  .data {
    color: $purple_color;
    font-weight: bold;
    font-size: 23px;
    margin-bottom: 5px;
  }
  .title {
    color: $mf_ft_color_lt;
    font-size: 20px;
  }
  .modalIcon {
    position: absolute;
    top: 22%;
    right: 20%;
  }
}
</style>